import { render, staticRenderFns } from "./BatchCreateReductionsModal.vue?vue&type=template&id=19ebbe51&"
import script from "./BatchCreateReductionsModal.vue?vue&type=script&lang=js&"
export * from "./BatchCreateReductionsModal.vue?vue&type=script&lang=js&"
import style0 from "./BatchCreateReductionsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports